var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wy-stats-pie"},[_c('div',{staticClass:"wy-stats-pie-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{attrs:{"id":_vm.pieCharId}})])}
var staticRenderFns = []

export { render, staticRenderFns }